// extracted by mini-css-extract-plugin
export var divider = "_i7-0";
export var systemMessage = "_i7-1";
export var systemMessageWrapper = "_i7-2";